module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-6-bb6ea1d85d4509a4eee41b891975041c.webp";